const AuthPage = () => import(/* webpackChunkName: "auth" */'./containers/AuthPage');
const ActivateAccountPage = () => import(/* webpackChunkName: "auth" */'./containers/ActivateAccountPage');
const RegistrationMessagePage = () => import(/* webpackChunkName: "auth" */'./containers/RegistrationMessagePage');
const ForgotPasswordPage = () => import(/* webpackChunkName: "auth" */'./containers/ForgotPasswordPage');
const RestorePasswordPage = () => import(/* webpackChunkName: "auth" */'./containers/RestorePasswordPage');

/* eslint-disable */
export default {
  path: '/auth',
  name: 'auth',
  redirect: { name: 'home' },
  component: AuthPage,
  children: [
    {
      path: 'activate-account',
      name: 'activate-account',
      component: ActivateAccountPage,
    },
    {
      path: 'registration-message',
      name: 'registrationMessage',
      component: RegistrationMessagePage,
    },
    {
      path: 'forgot-password',
      name: 'forgotPassword',
      component: ForgotPasswordPage,
    },
    {
      path: 'restore-password',
      name: 'restorePassword',
      component: RestorePasswordPage,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/modules/Auth/routes.js